// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// Track Yandex Metrika hits on Turbo navigation
document.addEventListener("turbo:load", () => {
    if (typeof window.ym === "function") {
        window.ym(106259847, "hit", window.location.href, {
            title: document.title
        });
    }
});

// Also track before cache to ensure hits are registered
document.addEventListener("turbo:before-cache", () => {
    if (typeof window.ym === "function") {
        window.ym(106259847, "hit", window.location.href);
    }
});

// Lodash
import _ from "lodash"
window._ = _

// Hotwired Turbo & Stimulus
import "@hotwired/turbo-rails"
import "../controllers/index.js"

// is.js - browser detection library
import is from "is_js"
window.is = is

// Feather Icons
import feather from "feather-icons"
window.feather = feather

import SimpleBar from "simplebar"
window.SimpleBar = SimpleBar

// AnchorJS
import AnchorJS from "anchor-js"
window.AnchorJS = AnchorJS

// Bootstrap 5
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

// Phoenix theme configuration
// Import config first and expose to window
const configModule = await import("../vendor/phoenix/config.js")
window.config = configModule.default

// Now import phoenix (it needs window.config and window.is to be set)
const phoenixModule = await import("../vendor/phoenix/phoenix.js")
window.phoenix = phoenixModule.default

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
